import { render } from "./Concept_index_m.vue?vue&type=template&id=87667324&scoped=true"
import script from "./Concept_index_m.vue?vue&type=script&lang=js"
export * from "./Concept_index_m.vue?vue&type=script&lang=js"

import "./Concept_index_m.vue?vue&type=style&index=0&id=87667324&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-87667324"

export default script